export default __webpack_public_path__ + "static/media/consensys.8c846c25.svg";